import { GPS, TrapSite } from "../../../types";
import { EditorDevice, StagedMoves } from "./types";

export const hasStagedMoves = (staged: StagedMoves): boolean =>
  Object.keys(staged.devices).length > 0 ||
  Object.keys(staged.trapSites).length > 0;

/**
 * Collection locations with any staged drag applied.
 *
 * The proximity warning has to read the position the user can see, not the one
 * still in the database - otherwise dragging a location onto its trap leaves
 * the "too far away" warning standing.
 */
export const applyStagedSites = (
  trapSites: Partial<TrapSite>[],
  staged: StagedMoves,
): Partial<TrapSite>[] =>
  trapSites.map((site) => {
    const moved = site._id ? staged.trapSites[site._id] : undefined;
    return moved ? { ...site, gps: moved } : site;
  });

/** Devices with any staged drag applied. */
export const applyStagedDevices = (
  devices: EditorDevice[],
  staged: StagedMoves,
): EditorDevice[] =>
  devices.map((device) => {
    const moved = staged.devices[device.uuid];
    return moved ? { ...device, gps: moved } : device;
  });

/** The staged device drags, as save-ready pairs. */
export const stagedDeviceEntries = (
  staged: StagedMoves,
): Array<[string, GPS]> => Object.entries(staged.devices);

/** The staged location drags, as save-ready pairs. */
export const stagedSiteEntries = (staged: StagedMoves): Array<[string, GPS]> =>
  Object.entries(staged.trapSites);
